import { getImageFromAssetFolder } from "../../../utils/assets";
import { colors } from "../../../theme/colors";

const features = [
  {
    icon: getImageFromAssetFolder("ic_feature_tracker.png"),
    title: "Syllabus Tracking",
    text: "Tracking your syllabus helps you stay on track and ensure consistent progress.",
  },
  {
    icon: getImageFromAssetFolder("ic_feature_exam.png"),
    title: "Quality Quizzes",
    text: "Attempting a variety of high-quality quizzes helps you gauge your preparation level effectively.",
  },
  {
    icon: getImageFromAssetFolder("ic_feature_trends.png"),
    title: "Trends & Analytics",
    text: "Analyzing trends and metrics, such as percentage scores and time taken per question, helps you identify areas for improvement.",
  },
  {
    icon: getImageFromAssetFolder("ic_feature_report.png"),
    title: "Detailed Quiz Analysis",
    text: "A thorough analysis of quiz results helps you pinpoint concepts and topics that need more focus and attention.",
  },
];

const Features = () => {
  return (
    <div className="p-16 rounded-xl flex flex-col items-center">
      <h3 className="text-center text-2xl font-semibold" style={{ margin: 0 }}>
        Features
      </h3>
      <p className="text-center text-gray-600" style={{ margin: 0 }}>
        Unlock Features Designed to Help You Excel
      </p>
      <div className="grid grid-cols-2 gap-8 justify-items-center mt-8">
        {features.map((feature) => {
          return (
            <div className="card w-80">
              <div vertical>
                <img
                  preview={false}
                  src={feature.icon}
                  style={{ height: 60, width: 60, marginRight: 16 }}
                />
                <h5 className="text-md">{feature.title}</h5>
                <p className="text-sm text-gray-600">{feature.text}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div id="working"></div>
    </div>
  );
};

export default Features;
